import { Flex, Paper, type PaperProps } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import s from './AuthFlowPageShell.module.scss';

export type AuthFlowPageShellProps = {
  children: React.ReactNode;
  wideContainer?: boolean;
} & Pick<PaperProps, 'radius' | 'shadow' | 'withBorder'>;

const AuthFlowPageShell: React.FC<AuthFlowPageShellProps> = ({
  children,
  wideContainer = false,
  radius = 'md',
  shadow = 'sm',
  withBorder = true,
}) => {
  return (
    <Flex justify="center" className={s.root}>
      <Paper
        className={cn(s.root__container, wideContainer && s['root__container-wide'])}
        radius={radius}
        shadow={shadow}
        withBorder={withBorder}
      >
        <div className={s.root__fill}>{children}</div>
      </Paper>
    </Flex>
  );
};

export default AuthFlowPageShell;
